import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Bell } from "lucide-react";
import { fmtDateTime } from "@/lib/insightsApi";

export function NotificationBell() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({ notifications: [], unread: 0 });
  const ref = useRef(null);
  const navigate = useNavigate();

  const load = () => api.get("/alerts/notifications").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, []);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h); return () => document.removeEventListener("mousedown", h);
  }, []);

  const openNote = async (n) => {
    if (!n.read) { await api.post(`/alerts/notifications/${n.notification_id}/read`).catch(() => {}); }
    setOpen(false); load();
    if (n.link) navigate(n.link);
  };
  const markAll = async () => { await api.post("/alerts/notifications/read-all").catch(() => {}); load(); };

  return (
    <div className="relative" ref={ref}>
      <button data-testid="notifications-bell" aria-label="Notifications" onClick={() => { setOpen((o) => !o); load(); }}
        className="relative text-slate-500 hover:text-brand-navy transition-colors">
        <Bell className="h-5 w-5" />
        {data.unread > 0 && (
          <span data-testid="notifications-unread-count"
            className="absolute -top-1.5 -right-1.5 h-4 min-w-4 px-1 rounded-full bg-red-500 text-[10px] font-bold text-white flex items-center justify-center">
            {data.unread}
          </span>
        )}
      </button>
      {open && (
        <div data-testid="notifications-panel"
          className="absolute right-0 mt-2 w-80 max-h-96 overflow-auto rounded-xl border border-brand-line bg-white shadow-lg z-50">
          <div className="flex items-center justify-between px-4 py-2.5 border-b border-brand-line sticky top-0 bg-white">
            <span className="text-sm font-bold text-brand-ink">Notifications</span>
            {data.unread > 0 && (
              <button onClick={markAll} data-testid="notifications-mark-all" className="text-xs font-semibold text-brand-civic hover:underline">
                Mark all read
              </button>
            )}
          </div>
          {data.notifications.length === 0 ? (
            <p className="px-4 py-8 text-center text-sm text-slate-400">You're all caught up.</p>
          ) : (
            data.notifications.slice(0, 15).map((n) => (
              <button key={n.notification_id} data-testid="notification-item" onClick={() => openNote(n)}
                className={`w-full text-left px-4 py-3 border-b border-brand-line/60 hover:bg-brand-bg transition-colors ${n.read ? "" : "bg-brand-civic-50/40"}`}>
                <div className="flex items-start gap-2">
                  {!n.read && <span className="mt-1.5 h-2 w-2 rounded-full bg-brand-civic shrink-0" />}
                  <div className={n.read ? "pl-4" : ""}>
                    <div className="text-sm font-semibold text-brand-ink">{n.title}</div>
                    <div className="text-xs text-slate-500">{n.message}</div>
                    <div className="text-[10px] text-slate-400 mt-0.5">{fmtDateTime(n.created_at)}</div>
                  </div>
                </div>
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
}
